const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    ai: {
      root: `${ROOTS.DASHBOARD}/ai`,
    },
    notifications: {
      root: `${ROOTS.DASHBOARD}/notifications`,
      details: (id) => `${ROOTS.DASHBOARD}/notifications/${id}`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
    },
    role: {
      root: `${ROOTS.DASHBOARD}/role`,
      new: `${ROOTS.DASHBOARD}/role/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/role/${id}/edit`,
    },
    client: {
      root: `${ROOTS.DASHBOARD}/role`,
      new: `${ROOTS.DASHBOARD}/role/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/role/${id}/edit`,
    },
    clients: {
      root: `${ROOTS.DASHBOARD}/clients`,
      details: (id) => `${ROOTS.DASHBOARD}/clients/${id}`,
    },
    jobs: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
    },
    applications: {
      applied: `${ROOTS.DASHBOARD}/application/applied`,
      received: `${ROOTS.DASHBOARD}/application/received`,
      root: `${ROOTS.DASHBOARD}/application`,
    },
    application: {
      details: (jobId, candidateShortUrl) => `${ROOTS.DASHBOARD}/application/${jobId}/${candidateShortUrl}`,
      updateStatus: (jobId, id) => `${ROOTS.DASHBOARD}/application/${jobId}/${id}/status`,
    },
    talent: {
      root: `${ROOTS.DASHBOARD}/talent`,
      new: `${ROOTS.DASHBOARD}/talent/new`,
      list: `${ROOTS.DASHBOARD}/talent`,
      edit: (id) => `${ROOTS.DASHBOARD}/talent/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/talent/${id}`,
      profile: (short_url) => `${ROOTS.DASHBOARD}/talent/${short_url}`,
      hired: `${ROOTS.DASHBOARD}/talent/hired`,
    },
    leads: {
      root: `${ROOTS.DASHBOARD}/leads`,
      list: `${ROOTS.DASHBOARD}/leads`,
      new: `${ROOTS.DASHBOARD}/leads/new`,
      details: (id) => `${ROOTS.DASHBOARD}/leads/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/leads/${id}/edit`,
    },
    agency: {
      root: `${ROOTS.DASHBOARD}/agency`,
      new: `${ROOTS.DASHBOARD}/agency/new`,
      list: `${ROOTS.DASHBOARD}/agency`,
      edit: (id) => `${ROOTS.DASHBOARD}/agency/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/agency/${id}`,
    },
    organization: {
      root: `${ROOTS.DASHBOARD}/organization`,
      new: `${ROOTS.DASHBOARD}/organization/new`,
      list: `${ROOTS.DASHBOARD}/organization`,
      edit: (id) => `${ROOTS.DASHBOARD}/organization/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/organization/${id}`,
    },
    talentTypes: {
      root: `${ROOTS.DASHBOARD}/talent-types`,
      edit: (id) => `${ROOTS.DASHBOARD}/talent-types/${id}/edit`,
      new: `${ROOTS.DASHBOARD}/talent-types/new`,
    },
    talentOffers: {
      root: `${ROOTS.DASHBOARD}/talent-offers`,
    },
    representationAgreements: {
      root: `${ROOTS.DASHBOARD}/representation-agreements`,
      detail: (id) => `${ROOTS.DASHBOARD}/representation-agreements/${id}`,
    },
    chats: {
      root: `${ROOTS.DASHBOARD}/chats`,
    },
    locations: {
      root: `${ROOTS.DASHBOARD}/location`,
      details: (id) => `${ROOTS.DASHBOARD}/location/${id}`,
    },
    equipments: {
      root: `${ROOTS.DASHBOARD}/equipment`,
      details: (id) => `${ROOTS.DASHBOARD}/equipment/${id}`,
    },
    proposals: {
      root: `${ROOTS.DASHBOARD}/proposals`,
      list: `${ROOTS.DASHBOARD}/proposals/list`,
      details: (id) => `${ROOTS.DASHBOARD}/proposals/${id}`,
    },
    auditions: {
      root: `${ROOTS.DASHBOARD}/auditions`,
      details: (id) => `${ROOTS.DASHBOARD}/auditions/${id}`,
    },
    geo: {
      root: `${ROOTS.DASHBOARD}/geo`,
      countries: `${ROOTS.DASHBOARD}/geo/countries`,
      states: `${ROOTS.DASHBOARD}/geo/states`,
      cities: `${ROOTS.DASHBOARD}/geo/cities`,
      taxRates: `${ROOTS.DASHBOARD}/geo/tax-rates`,
    },
    services: {
      root: `${ROOTS.DASHBOARD}/services`,
      new: `${ROOTS.DASHBOARD}/services/new`,
    },
    languages: {
      root: `${ROOTS.DASHBOARD}/languages`,
    },
    contactForms: {
      root: `${ROOTS.DASHBOARD}/contact-forms`,
      details: (id) => `${ROOTS.DASHBOARD}/contact-forms/${id}`,
    },
    testimonials: {
      root: `${ROOTS.DASHBOARD}/testimonials`,
      new: `${ROOTS.DASHBOARD}/testimonials/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/testimonials/${id}/edit`,
    },
    contracts: {
      root: `${ROOTS.DASHBOARD}/contracts`,
      details: (id) => `${ROOTS.DASHBOARD}/contracts/${id}`,
    },
    sharedMedia: {
      root: `${ROOTS.DASHBOARD}/shared-media`,
    },
    accessRequests: {
      root: `${ROOTS.DASHBOARD}/access-requests`,
    },
    projects: {
      root: `${ROOTS.DASHBOARD}/projects`,
      details: (id) => `${ROOTS.DASHBOARD}/projects/${id}`,
    },
    bookings: {
      root: `${ROOTS.DASHBOARD}/bookings`,
    },
    campaigns: {
      root: `${ROOTS.DASHBOARD}/campaigns`,
      email: `${ROOTS.DASHBOARD}/campaigns/email`,
      whatsapp: `${ROOTS.DASHBOARD}/campaigns/whatsapp`,
      leads: `${ROOTS.DASHBOARD}/campaigns/leads`,
    },
    likeness: {
      root: `${ROOTS.DASHBOARD}/likeness`,
      optIns: `${ROOTS.DASHBOARD}/likeness/opt-ins`,
      terms: `${ROOTS.DASHBOARD}/likeness/terms`,
      package: `${ROOTS.DASHBOARD}/likeness/package`,
      requests: `${ROOTS.DASHBOARD}/likeness/requests`,
    },
    accountDeletions: {
      root: `${ROOTS.DASHBOARD}/account-deletions`,
    },
    jobLeads: {
      root: `${ROOTS.DASHBOARD}/job-leads`,
      list: `${ROOTS.DASHBOARD}/job-leads`,
      details: (id) => `${ROOTS.DASHBOARD}/job-leads/${id}`,
      brightData: `${ROOTS.DASHBOARD}/job-leads/scrape-jobs`,
    },
    serviceLeads: {
      root: `${ROOTS.DASHBOARD}/service-leads`,
    },
    filmMonitor: {
      root: `${ROOTS.DASHBOARD}/film-monitor`,
      project: (id) => `${ROOTS.DASHBOARD}/film-monitor/${id}`,
    },
    voices: {
      root: `${ROOTS.DASHBOARD}/voices`,
    },
  },
};
  
